import { FirebaseService } from '../firebase.service';
import { Injectable } from '@angular/core';


@Injectable({
  providedIn: 'root'
})
export class BannerService {

  private path: string = 'banner';
  

  constructor(public firebaseService: FirebaseService) {
  }

  list() {
    return this.firebaseService.getList(this.path);
  }


  listOrderAsc(order) {
    return this.firebaseService.getOrderListAsc(this.path, order)
  }

  get(id) {
    return this.firebaseService.getObject(this.path,id);
  }

  add(doc) {
    return this.firebaseService.addItem(this.path, doc);
  }

  update(id, doc) {
    return this.firebaseService.updateItem(this.path,id, doc);
  }

  remove(id) {
    return this.firebaseService.removeItem(this.path, id);
  }

  getByField(campo, valor){
    return this.firebaseService.query(this.path, ref => ref.where(campo, '==', valor));
  }

  getByFieldOrdener(campo, valor, order){
    return this.firebaseService.query(this.path, ref => ref.where(campo, '==', valor).orderBy(order, 'asc'));
  }


  addItemColecao(colecao, id, item){
    return this.firebaseService.addItemCollection(this.path, id, colecao, item );
  }

  updateItemColecao(colecao, id, item){
    return this.firebaseService.updateItemCollection(this.path, id, colecao, item );
  }

  removeItemCollection(colecao, id, item){
    return this.firebaseService.removeItemCollection(this.path, id, colecao, item );
  }

  getCollection(item, collection){
    return this.firebaseService.getCollection(this.path, item, collection);
  }

  getCollectionOrdener(item, collection, field){
    return this.firebaseService.getCollectionOrdener(this.path, item, collection, field);
  }
  
  getItemCollection(colecao, id, item){
    return this.firebaseService.getItemCollection(this.path, id, colecao, item );
  }
}
